export function Footer() {
  return (
    <footer className="border-t border-[#33240E]/15 py-16" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 lg:flex-row lg:items-end lg:justify-between lg:px-12">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-[#8A5A0F]">Be Kind Community Inc</p>
          <p className="mt-2 font-serif text-4xl font-black italic text-[#33240E]">See you at the Ball.</p>
        </div>
        <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
          <p>08.19.26 — 12.19.26</p>
          <p className="mt-1">121 activations · 1,000 bears · 1,000,000 pledges</p>
        </div>
      </div>
    </footer>
  );
}
